import { SearchResults } from "@/core/models/results";
import { Fragment, FunctionalComponent, h } from "@stencil/core";
import { theme } from "@/utils/theme";

interface EmissionsBoxComponentProps {
  results: SearchResults;
  onAircraftTypeClick: () => void;
}

function floatToLocaleString(number: number): string {
  return number?.toLocaleString(window.navigator.language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export const EmissionsBoxComponent: FunctionalComponent<
  EmissionsBoxComponentProps
> = ({ results, onAircraftTypeClick }) => (
  <Fragment>
    <div class="row no-spacing">
      <div class="col-8">
        <h2>CO2 (KG)</h2>
      </div>
    </div>

    <div class="row no-spacing">
      <div class={"col-8 emissions-figure"}>
        <span
          class={`digits-${floatToLocaleString(results.emissionsTotal).length}`}
        >
          {floatToLocaleString(results.emissionsTotal)}
        </span>
      </div>
      <div class="col-8">
        <p>
          Per passenger per flight:{" "}
          {results.emissionsPerPassenger?.toLocaleString(
            window.navigator.language,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            },
          )}{" "}
          CO2 (KG)
        </p>
      </div>
    </div>

    <div class="row"></div>

    <div class="row">
      <div class="col-8">
        <h2>AIRCRAFT TYPE</h2>
        <p>(Click below to see the aircraft details)</p>
        <p>
          <a style={theme.getLinkStyle()} onClick={() => onAircraftTypeClick()}>
            {results.aircraftTypeName}
          </a>
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <h2>DISTANCE</h2>
        <p>{results.distance.toLocaleString()} KM</p>
      </div>
    </div>
  </Fragment>
);
